// Spanish
export const es = {
    weeklyRewards: 'Recompensas semanales en',
    days: 'días',
    hours: 'horas',
    minutes: 'min',
    seconds: 'seg',
    authenticating: 'Autenticando',
    verifyWallet: 'Por favor espere mientras verificamos su billetera',
    authRequired: 'Autenticación requerida',
    authFailed: 'Autenticación fallida. Por favor, inténtelo de nuevo.',
    points: 'Puntos',
    rank: 'Rango',
    of: 'de',
    players: 'jugadores',
    weeklyTopPlayers: 'Mejores jugadores de la semana',
    thisWeekLeaderboard: 'Clasificación de esta semana',
    rankingsReset: 'La clasificación se reinicia cada domingo a medianoche UTC',
    yourPoints: 'Tus puntos',
    dailyRewardAvailable: '¡Recompensa diaria disponible!',
    nextClaimAvailable: 'Próximo reclamo disponible en:',
    claimDailyReward: 'Reclamar recompensa diaria',
    claiming: 'Reclamando...',
    multiplier: 'Multiplicador',
    bonusPointsMultiplier: 'Multiplicador de puntos bonus',
    outOf: 'de',
    loading: 'Cargando...',
    errorLoading: 'Error al cargar',
    noEntries: 'Sin entradas',
    leaderboard: 'Tabla de clasificación',
    topPerformers: 'Mejores jugadores del período seleccionado',
    week: 'Semana',
    year: 'Año',
    tasks: 'Tareas',
    rules: 'Reglas',
    profile: 'Perfil',
    comingSoon: 'Próximamente...',
    completedTasks: 'Actividades\ncompletadas',
    dailyRewardsClaimed: 'Recompensas diarias reclamadas',
    times: 'veces',
    recentActivity: 'Actividad Reciente',
    noRewardsClaimed: 'Aún no se han reclamado recompensas',
    dailyReward: 'Recompensa Diaria',
    howItWorks: 'Cómo funciona',
    welcomeMessage:
        '¡Bienvenido a Coinomi Rewards! Gana puntos completando varias tareas y sube en la clasificación.',
    dailyRewardsTitle: 'Recompensas diarias',
    dailyRewardsRules: [
        'Reclama tu recompensa diaria cada 24 horas',
        'Cada reclamo vale 100 puntos',
        'Los puntos se multiplican por tu multiplicador',
    ],
    multiplierBonusesTitle: 'Bonos multiplicadores',
    multiplierBonusesRules: [
        'Comienza con multiplicador 1x',
        'Conecta Telegram para bono +10%',
        'Verifica email para bono +10%',
        'Los bonos se acumulan para recompensas máximas',
    ],
    leaderboardTitle: 'Clasificación',
    leaderboardRules: [
        'Compite con otros jugadores',
        'Clasificación actualizada en tiempo real',
        'Los mejores jugadores reciben recompensas especiales',
    ],
    boostEarningsTitle: 'Aumenta tus ganancias',
    boostEarningsRules: [
        'Completa desafíos para bonos',
        'Únete a nuestra comunidad de Telegram',
        'Mantente activo para recompensas máximas',
    ],
    challenges: 'Desafíos',
    telegramChallenge: 'Desafío Telegram',
    emailChallenge: 'Desafío Email',
    connectTelegram: 'Conectar Telegram',
    shareEmail: 'Compartir email',
    telegramSuccess:
        '🎉 ¡Felicitaciones! ¡Ahora recibes un bono permanente del 10% en todas las recompensas!',
    telegramPrompt:
        '¡Conecta tu cuenta de Telegram para recibir un bono permanente del 10% en todas las recompensas!',
    emailSuccess:
        '🎉 ¡Felicitaciones! ¡Ahora recibes un bono permanente del 10% en todas las recompensas!',
    emailPrompt:
        '¡Comparte tu email para recibir un bono permanente del 10% en todas las recompensas!',
    connectEmail: 'Conectar email',
    cancel: 'Cancelar',
    emailPrivacy:
        'Solo usamos tu email para actualizaciones importantes y notificaciones de recompensas.',
    connectYourEmail: 'Conecta tu email',
    emailBonus:
        '🎉 ¡Recibe un bono permanente del 10% en todas las recompensas conectando tu email!',
    enterValidEmail: 'Por favor, introduce una dirección de email válida',
    emailAddress: 'Dirección de email',
    errorSavingEmail: 'Error al guardar el email. Por favor, inténtalo de nuevo.',
    claimButton: 'Reclamar',
    earnedReward: 'Recompensa ganada',
    rewardValue: '{{amount}} Puntos',
    claimSuccess: '¡Reclamado con éxito {{amount}} puntos!',
    claimError: 'Error al reclamar. Por favor, inténtalo de nuevo.',
    privacyDisclaimer:
        'Coinomi no recopila datos personales; un sistema de terceros gestiona de forma segura los puntos y conexiones sociales.',
    streakBonus: 'Bono de racha',
    streakDays: '{{days}}/5 Días',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% Extra',
    streakDescription: 'Reclama 5 días seguidos para el bono máximo',
    streakToday: 'Hoy',
    streakMissed: 'Perdido',
    streakComplete: 'Completo',
    streakActive: 'Racha activa',
    streakLost: 'Racha perdida',
    streakNext: 'Siguiente',
    home: 'Inicio',
    currentStreak: 'Racha actual',
    totalClaims: 'Total de reclamos',
    userStats: 'Tus estadísticas',
    referrals: 'Referencias',
    referralProgram: 'Programa de referencias',
    howReferralWorks: 'Cómo funcionan las referencias:',
    referralSteps: [
        'Comparte tu enlace de referencia con amigos',
        'Cuando se unen a través de tu enlace, se convierten en tus referidos',
        'Gana puntos bonus por cada referencia activa',
        'Rastrea tus referencias y ganancias aquí',
    ],
    referralRewards: 'Puntos de referencia otorgados:',
    referralBonuses: [
        '100 puntos por referencia',
        '10% de todos los puntos ganados por tus referidos',
    ],
    yourReferralLink: 'Tu enlace de referencia',
    copyToClipboard: 'Copiar al portapapeles',
    linkCopied: '¡Enlace copiado al portapapeles!',
    totalReferrals: 'Total de referencias',
    yourReferralCode: 'Tu código de referencia',
    referralCodeCopied: '¡Código de referencia copiado!',
    editReferralCode: 'Editar código de referencia',
    editReferralCodeInstructions:
        'Elige un nuevo código de referencia. Debe tener mínimo 5 caracteres y puede incluir letras y números.',
    newReferralCode: 'Nuevo código de referencia',
    referralCodeRequirements: 'Mínimo 5 caracteres, solo letras y números',
    updating: 'Actualizando...',
    update: 'Actualizar',
    referralCodeTaken: 'Este código de referencia ya está en uso',
    haveReferralCode: '¿Tienes un código de referencia?',
    enterReferralCodePrompt:
        'Si alguien te refirió, ingresa su código aquí para conectar las cuentas.',
    enterReferralCode: 'Ingresar código de referencia',
    enterReferralCodeInstructions: 'Ingresa el código de referencia que se compartió contigo.',
    referralCode: 'Código de referencia',
    referralCodeFormat: 'Solo letras y números',
    submitting: 'Enviando...',
    submit: 'Enviar',
    enterCode: 'Ingresar código',
    pleaseAddtoken: 'Por favor, añade el parámetro token a la URL',
    authenticationError: 'Ocurrió un error durante la autenticación',
    noUserFound: 'No se encontró usuario',
    userNotFoundMessage: 'No se pudieron encontrar los datos del usuario',
    backToHome: 'Volver al inicio',
    retry: 'Reintentar',
    baseMultiplier: 'Multiplicador base',
    telegramBonus: 'Bono Telegram',
    referralChallenge: 'Desafío de referencias',
    referralChallengePrompt:
        '¡Invita amigos y gana puntos bonus! Recibe 100 puntos por cada referencia más 10% de sus ganancias.',
    startReferring: 'Comenzar a referir',
    referralSuccess:
        '🎉 ¡Felicitaciones! ¡Has referido usuarios exitosamente y estás ganando puntos bonus!',
    unranked: 'Sin clasificar',
    noPlayersYet: '¡Sé el primero en unirte!',
    shareVia: 'Compartir vía',
    shareOn: 'Compartir en {{network}}',
    shareInviteText:
        '🚀 ¡Estoy ganando crypto gratis con @CoinomiWallet!\n\nDescarga Coinomi en coinomi.com/downloads e ingresa mi código de referido {{referralCode}} para obtener un bono cuando te unas a #Coinomi Rewards en la app.',
    yourStatsThisWeek: 'Tus estadísticas esta semana',
    pointsMultiplier: 'Multiplicador\nde puntos',
    yourRank: 'Tu\nrango',
    rewards: 'Recompensas',
    daily: 'Diario',
    weekly: 'Semanal',
    claimRewards: 'Reclamar recompensas',
    privacyTitle: 'Coinomi no recopila datos personales',
    privacyDescription:
        'Un sistema de terceros gestiona de forma segura los puntos y los enlaces sociales.',
    walletAddress: 'Dirección de la cartera',
    darkMode: 'Modo oscuro',
    pointsAvailable: 'Puntos disponibles',
    player: 'Jugador',
    score: 'Puntos',
    youHaveReferred_zero: 'No has referido a ningún amigo todavía',
    youHaveReferred_one: 'Has referido a 1 amigo',
    youHaveReferred_other: 'Has referido a {{count}} amigos',
    referYourFriends: 'Invita a tus amigos',
    dailyRewardTooltip: 'Vuelve cada día para reclamar tus puntos y recompensas',
    weeklyRewardTooltip: 'Las recompensas se distribuyen semanalmente',
    'new-referral': 'Nueva Referencia',
    'daily-reward': 'Recompensa Diaria',
    'referral-bonus': 'Bono de Referencia',
    copy: 'Copiar',
    // Twitter Challenge
    twitterChallenge: 'Desafío de Twitter',
    connectTwitter: 'Conectar con Twitter',
    twitterSuccess:
        '🎉 ¡Felicidades! Ahora recibirás un bono permanente del 10% en todas las recompensas!',
    twitterPrompt:
        '¡Vincula tu cuenta de Twitter para obtener un bono permanente del 10% en todas las recompensas!',
    pleaseAddUserId: 'Please add a userId parameter to the URL',
    emailChallengePrompt: 'Share your email to get a permanent 10% bonus on all rewards!',
    emailChallengeSuccess:
        '🎉 Connected! You are now receiving a permanent 10% bonus on all rewards!',
    followKoalaWalletChallenge: 'Follow @coinomiWallet on Twitter to support us!',
    twitterAuthSuccessTitle: 'Twitter Connected Successfully!',
    twitterAuthSuccessMessage:
        'You have successfully connected your Twitter account. You can now continue using the app.',
    continueToApp: 'Continue to App',
    twitter_like: 'Liked a tweet',
    twitter_retweet: 'Retweeted a tweet',
    disconnect: 'Desconectar',
    followCoinomiWallet: 'Sigue a @coinomiWallet en Twitter para apoyarnos!',
    connectedBonus:
        '🎉 ¡Conectado! ¡Ahora recibes un bono permanente del 10% en todas las recompensas!',
};
